module.exports = __webpack_public_path__ + "img/avatar-default.0f944fba.png";